import { render, staticRenderFns } from "./PrivacyPageHero.vue?vue&type=template&id=27b62c5e&scoped=true"
import script from "./PrivacyPageHero.vue?vue&type=script&lang=js"
export * from "./PrivacyPageHero.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPageHero.vue?vue&type=style&index=0&id=27b62c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b62c5e",
  null
  
)

export default component.exports